import { render, staticRenderFns } from "./questionAnswerOther.vue?vue&type=template&id=35a15944&scoped=true"
import script from "./questionAnswerOther.vue?vue&type=script&lang=js"
export * from "./questionAnswerOther.vue?vue&type=script&lang=js"
import style0 from "./questionAnswerOther.vue?vue&type=style&index=0&id=35a15944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a15944",
  null
  
)

export default component.exports